var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myheader"},[_c('h3',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }